import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Section } from "@/components/common";

export default function Terms() {
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/terms").then((r) => setT(r.data)).catch(() => {}); }, []);
  return (
    <Section title="Términos y condiciones" subtitle={t?.platform_name}>
      <div className="neon-card p-5 sm:p-8 text-sm leading-relaxed whitespace-pre-wrap" data-testid="terms-text">{t?.terms_text || "Cargando…"}</div>
    </Section>
  );
}
